import React from "react";
import DataTable from "./DataTable";
import MatrixView from "./MatrixView";
import ChartRenderer from "./ChartRenderer";

const HEATMAP_TYPES = new Set(["correlation", "pca", "cluster"]);
const MATRIX_TITLES = {
  chisquare: "Observed vs. expected",
  logistic: "Confusion matrix",
  anova: "Tukey pairwise comparisons",
  turf: "Greedy selection steps",
  correlation: "Correlation heatmap",
  pca: "Component loadings",
  cluster: "Cluster profile (variable means)",
};

/** Renders one saved/just-run analysis envelope: narrative, summary, table, matrix, chart. */
function AnalysisResults({ analysisType, analysisLabel, result }) {
  if (!result) return null;
  const { summary, table, matrix, chart, narrative } = result;

  return (
    <div className="analysis-results-block">
      <h3>{analysisLabel}</h3>
      {narrative && <p className="analysis-narrative">{narrative}</p>}

      {summary && Object.keys(summary).length > 0 && (
        <div className="analysis-summary-badges">
          {Object.entries(summary).map(([k, v]) => (
            Array.isArray(v) || (v && typeof v === "object") ? null : (
              <div className="analysis-badge" key={k}>
                <span className="analysis-badge-label">{k}</span>
                <span className="analysis-badge-value">{typeof v === "number" ? (Number.isInteger(v) ? v : v.toFixed(3)) : String(v)}</span>
              </div>
            )
          ))}
        </div>
      )}

      <ChartRenderer chart={chart} />

      <DataTable rows={table} title="Results" exportName={`${analysisType}_results`} />

      <MatrixView matrix={matrix} heatmap={HEATMAP_TYPES.has(analysisType)} title={MATRIX_TITLES[analysisType]} />
    </div>
  );
}

export default AnalysisResults;
